<template>
  <v-dialog
    persistent
    width="500"
    max-width="90vw"
    data-test="v-dialog">
    <v-card>
      <v-card-item>
        <v-card-title>
          <!-- @slot Use this slot to populate the header -->
          <slot name="text-header">
            {{ props.title || "Are you sure?" }}
          </slot>
        </v-card-title>
        <v-card-subtitle
          v-if="$slots['text-subtitle']">
          <!-- @slot Use this slot to populate the subtitle -->
          <slot name="text-subtitle" />
        </v-card-subtitle>
      </v-card-item>
      <v-card-text data-test="confirmation-dialog-text">
        <!-- @slot Use this slot populate the body -->
        <slot name="text-body">
          {{ props.content }}
        </slot>
      </v-card-text>
      <v-card-actions>
        <CancelButton
          @click="emit('confirmation-selection', false)"
          :disabled="isLoading"
          data-test="cancel-button">
          <!-- @slot Use this slot to populate the abort button text -->
          <slot name="button-abort">
            No
          </slot>
        </CancelButton>
        <PrimaryButton
          data-test="confirmation-button"
          :loading="isLoading"
          @click="emit('confirmation-selection', true)">
          <!-- @slot Use this slot to populate the confirm button text -->
          <slot name="button-confirm">
            Yes
          </slot>
        </PrimaryButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { CancelButton, PrimaryButton } from "@/components/buttons";

const props = defineProps<{
  title?: string;
  content?: string;
  isLoading?: boolean;
}>();

const emit = defineEmits<(e: "confirmation-selection", value: boolean) => void>();
</script>
